import { QueryFactory } from "../../../../Common";
export const QCalculateYourbetBets = QueryFactory("CalculateYourbetBets");
//# sourceMappingURL=QCalculateYourbetBets.js.map